import { useMemo } from 'react';

import { collection, CollectionReference, limit, orderBy, query, Query, QueryConstraint, where } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { firestore } from '../firebase';
import SystemError, { SystemErrorCategory } from '../types/SystemError';

interface UseSystemErrorsProps {
  category?: SystemErrorCategory | null;
  resolvedOnly?: boolean;
  unresolvedOnly?: boolean;
  maxResults?: number;
}

export default function useSystemErrors(props: UseSystemErrorsProps = {}) {
  const { category, resolvedOnly, unresolvedOnly, maxResults = 100 } = props;

  const systemErrorQuery = useMemo(() => {
    const conditions: QueryConstraint[] = [];

    if (category) {
      conditions.push(where('category', '==', category));
    }

    if (resolvedOnly) {
      conditions.push(where('resolved', '==', true));
    } else if (unresolvedOnly) {
      conditions.push(where('resolved', '==', false));
    }

    conditions.push(orderBy('createTime', 'desc'));
    conditions.push(limit(maxResults));

    return query(
      collection(firestore, 'systemError') as CollectionReference<SystemError>,
      ...conditions
    ) as Query<SystemError>;
  }, [category, resolvedOnly, unresolvedOnly, maxResults]);

  const [systemErrors, isSystemErrorsLoading, systemErrorsError] =
    useCollectionData<SystemError>(systemErrorQuery);

  return {
    systemErrors: systemErrors ?? [],
    isSystemErrorsLoading,
    systemErrorsError,
  };
}
